import { memo as Memo, useCallback, useEffect } from 'react';
import { gsap } from 'gsap';

const SharpyEyes = Memo(() => {
	useEffect(() => {
		window.addEventListener('mousemove', mouseMove);
		return () => {
			window.removeEventListener('mousemove', mouseMove);
			gsap.killTweensOf('.sharpyEyes-e');
			gsap.killTweensOf('.sharpyEyes-m');
		};
	}, []);

	const mouseMove = useCallback((e) => {
		const size = -5;
		const winWPart = window.innerWidth / 2;
		const winHPart = window.innerHeight / 2;
		const x = ((winWPart - e.clientX) / winWPart) * size;
		const y = ((winHPart - e.clientY) / winHPart) * size;

		gsap.killTweensOf('.sharpyEyes-e');
		gsap.killTweensOf('.sharpyEyes-m');

		gsap.to('.sharpyEyes-e', { duration: 0.5, x, y });
		gsap.to('.sharpyEyes-m', { duration: 0.5, x: x * 0.8, y: y * 0.8 });
	}, []);

	return (
		<svg
			className={`sharpyEyes svg-max`}
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 0 145.43 227.87'>
			<path
				className={'fill'}
				d='M145.43,184H0C0,82.38,65.11,0,145.43,0h0Z'
			/>
			<path
				className={`defaultStyle`}
				d='M88.38,200.83c-.11,5.36,0,25.54,0,25.54'
			/>
			<path
				className={`defaultStyle`}
				d='M88.24,176.28c.12,4.62,0,14.35.14,24'
			/>
			<line
				className={`defaultStyle`}
				x1='88.38'
				y1='226.37'
				x2='102.36'
				y2='226.37'
			/>
			<path
				className={`defaultStyle`}
				d='M64.22,200.83c.11,5.36,0,25.54,0,25.54'
			/>
			<path
				className={`defaultStyle`}
				d='M64.36,176.28c-.13,4.62,0,14.35-.14,24'
			/>
			<line
				className={`defaultStyle`}
				x1='64.22'
				y1='226.37'
				x2='50.24'
				y2='226.37'
			/>
			<path
				className={`sharpyEyes-e fillWhite`}
				d='M57.51,91.47V95H44.76V91.47Z'
			/>
			<path
				className={`sharpyEyes-e fillWhite`}
				d='M105.6,91.47V95H92.85V91.47Z'
			/>
			<path
				className={`sharpyEyes-m fillWhite`}
				d='M71,103.74l5.67,16.77,5.7-16.77h4.53l-7.5,21.18H74l-7.5-21.18Z'
			/>
		</svg>
	);
});

export default SharpyEyes;
